import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import AuthModal from '../components/auth/modals/AuthModal';
import StudentAuthModal from '../components/auth/modals/student/StudentAuthModal';
import useParentAuth from '../hooks/useParentAuth';

function WebLayout() {
  const [authOpen, setAuthOpen] = useState(false);
  const [authTab, setAuthTab] = useState(0); // 0 for login, 1 for register
  const [studentAuthOpen, setStudentAuthOpen] = useState(false);
  const [studentAuthView, setStudentAuthView] = useState('login');
  const { isAuthenticated } = useParentAuth();

  const handleOpenAuth = (tab) => {
    setAuthTab(tab);
    setAuthOpen(true);
  };

  const handleStudentOpenAuth = (view = 'login') => {
    if (isAuthenticated) {
      return;
    }

    setStudentAuthView(view);
    setStudentAuthOpen(true);
  };

  return (
    <div className="web-layout">
      <Navbar />
      <main>
        <Outlet
          context={{ onOpenAuth: handleOpenAuth, onOpenStudentAuth: handleStudentOpenAuth }}
        />
      </main>
      <Footer />

      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} defaultTab={authTab} />
      <StudentAuthModal
        open={studentAuthOpen}
        onClose={() => setStudentAuthOpen(false)}
        defaultView={studentAuthView}
      />
    </div>
  );
}

export default WebLayout;
